<div class="row">
  <!-- SECTION LABEL -->
  <div class="col-sm-12 divider" *ngIf="group.label && !homepage">
    <h3>{{ group.label }}</h3>
  </div>

  <!-- SECTION DESCRIPTION -->
  <div class=" col-12 description" *ngIf="group.description" [innerHTML]="group.description"></div>

  <!-- SECTION ITEMS -->
  <div *ngFor="let item of group.items.slice(0, toShow)" class="col-6 col-md-3">
    <pv-product-list-item #listItem
      [type_id]="group.type_id"
      [overlay_id]="group.overlay_id"
      [border]="true"
      [bundle]="item.typeCode == 'BUNDLE' && item.id"
      [id]="item.typeCode == 'PRODUCT' && item.id"
    ></pv-product-list-item>
  </div>

  <!-- LOAD MORE BUTTON -->
  <div class="col-12 load-more"
    *ngIf="group.items.length > toShow && !noShowMore"
    (click)="toShow  = (toShow || group.items_per_page) * 2">
    show more
  </div>
</div>